import { Check, ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { AppCanvas } from "@/components/app/AppCanvas";
import { Wordmark } from "@/components/landing/Wordmark";
import { Button } from "@/components/ui/button";
import { useSubscription } from "@/contexts/SubscriptionContext";
import { UpgradeButton, ManageSubscriptionButton } from "@/components/paywall";
import { formatProMonthlyPrice, PRO_FEATURES } from "@/lib/pricing";

const Upgrade = () => {
  const navigate = useNavigate();
  const { isPaid } = useSubscription();

  return (
    <AppCanvas>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => navigate(-1)}
        className="gap-2 text-neutral-500"
      >
        <ChevronLeft className="h-5 w-5" />
        Voltar
      </Button>

      {isPaid ? (
        <div className="mt-6 grid gap-8 lg:grid-cols-2 lg:items-start">
          <div>
            <p className="text-overline text-neutral-500">Assinatura</p>
            <h1 className="mt-2 text-h1 text-neutral-900">Talki Pro ativo</h1>
            <p className="mt-2 text-body text-neutral-500">
              Conversas liberadas — sem cota mensal. Gerencie cartão, faturas e cancelamento no portal Stripe.
            </p>
          </div>
          <div className="rounded-lg border border-neutral-200 bg-white px-6 py-8">
            <Wordmark to="/app" size="md" className="justify-center" />
            <p className="mt-6 text-center text-label text-neutral-500">Plano atual</p>
            <div className="mt-6 space-y-3">
              <ManageSubscriptionButton className="w-full" />
              <Button
                variant="ghost"
                className="w-full text-neutral-500"
                onClick={() => navigate("/app")}
              >
                Voltar para o app
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <div className="mt-6 grid gap-8 lg:grid-cols-2 lg:items-start">
          <div>
            <p className="text-overline text-blue-600">Talki Pro</p>
            <h1 className="mt-2 text-h1 text-neutral-900">Fale à vontade</h1>
            <p className="mt-2 text-body text-neutral-500">
              Uma assinatura, tudo liberado. Pague no site com Stripe — o mesmo Pro vale no computador e no celular.
            </p>
          </div>
          <div className="rounded-lg border-2 border-blue-500 bg-white px-6 pb-6 pt-7">
            <p className="text-center text-label text-blue-600">Mensal</p>
            <p className="mt-2 text-center text-display text-neutral-900">
              {formatProMonthlyPrice()}
              <span className="text-body text-neutral-500">/mês</span>
            </p>
            <ul className="mt-6 space-y-3">
              {PRO_FEATURES.map((feature) => (
                <li key={feature} className="flex items-center gap-2.5 text-body text-neutral-900">
                  <Check className="h-4 w-4 shrink-0 text-blue-500" />
                  {feature}
                </li>
              ))}
            </ul>
            <UpgradeButton fullWidth className="mt-7">
              Assinar agora
            </UpgradeButton>
            <p className="mt-3 text-center text-caption text-neutral-500">
              Cancele quando quiser. Sem compromisso.
            </p>
          </div>
        </div>
      )}
    </AppCanvas>
  );
};

export default Upgrade;
